export default {
  image: 'Kapsel_3.png',
  pdf: '220902_WA-EPS_003_Kapsel3_Rev02_ar.pdf',
  productData: {
    serialNumber: 'WA-EPS-003',
    technicalValues: {
      soundReductionIndex: {
        output: '58,7',
        value: 58.7
      },
      heatTransferCoefficient: {
        output: '0,11',
        value: 0.11
      },
      fireBehavior: {
        output: 'schwerentflammbar (B1)',
        value: 'B1'
      },
      fireResistanceOuter: {
        output: 'F 60-B / K\u208260' ,
        value: 'F-60-B-K260'
      },
      fireResistanceInner: {
        output: 'F 60-B / K\u208260' ,
        value: 'F-60-B-K260'
      }
    },
    name: 'Wandaufbau mit EPS l Aufbau 3',
    construction: {
      composition: [
        {
          output: 'mineralischer Unterputz',
          type: 'render',
          title: { de: 'Putz' },
          value: 'min-1'
        },
        {
          output: '140 mm Sto-Dämmplatte Top 32',
          type: 'pinsulation',
          title: { de: 'Dämmung' },
          value: 'pda-140'
        },
        {
          output: '15 + 18 mm Gipsfaserplatten',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: 'opg-33'
        },
        {
          output: '60/180',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-180'
        },
        {
          output: '180 mm Steinwolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'cirw-180'
        },
        {
          output: '15 mm Gipsfaserplatte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'ig-15'
        },
        {
          output: '18 mm Gipsfaserplatte',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: 'iq-18',
        },
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '395',
        value: 395
      }
    }
  }
}
